import { FunctionComponent } from 'react';

// import { loginAtom, renew_sign_in } from '../../lib/auth';
import { useTheme } from '@mui/material/styles';
// import { useAtom } from 'jotai';
import React from 'react';

import {
  Step,
  StepLabel,
  Stepper as Stppr
} from '@mui/material';

// const { DateTime } = require("luxon");

type Props = {
  steps: number;
  activeStep: number;
};

export const Stepper: FunctionComponent<Props> = ({steps, activeStep}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();

  return (<Stppr activeStep={activeStep} alternativeLabel sx={{
    "& .MuiStepConnector-root": {
      backgroundColor: theme.palette.primary.main,
      height: 4,
      top: 11
    },
    "& .Mui-completed .MuiStepConnector-root, & .Mui-active.MuiStepConnector-root": {
      backgroundColor: theme.palette.primary.light
    },
    "& .Mui-completed svg, & .Mui-active svg": {
      color: theme.palette.primary.light,
      width: '40px',
      height: '40px',
      marginTop: '-6px'
    },
    "& .Mui-disabled svg": {
      color: theme.palette.primary.main,
      width: '40px',
      height: '40px',
      marginTop: '-6px'
    }
  }}>
    {Array.from({length: steps},(_, index) => <Step key={index}>
      <StepLabel />
    </Step>)}
  </Stppr>);
}
